export default __webpack_public_path__ + "static/media/holidays.7aaf70cc.png";